/* eslint-disable */
/// <reference path="../react-app-env.d.ts" />
import "url-polyfill";
import smoothscroll from "smoothscroll-polyfill";

const userAgent = window.navigator.userAgent;
const isIE =
	userAgent.indexOf("MSIE ") >= 0 || userAgent.indexOf("Trident/") >= 0;

const polyfills = [];

if (!Element.prototype.hasOwnProperty("inert") && window.MutationObserver) {
	polyfills.push("DOM.inert");
	require("wicg-inert");
}

// object
declare const Object: Object & {
	setPrototypeOf?: Function;

	defineProperty: Function;

	prototype: {
		constructor: {
			assign?: Function;
			values?: Function;
			setPrototypeOf?: Function;
		};
	};
};

if (!Object.prototype.constructor.assign) {
	polyfills.push("Object.assign");
	require("core-js/es/object/assign");
}

if (!Object.prototype.constructor.values) {
	polyfills.push("Object.values");
	require("core-js/es/object/values");
}

if (!Object.prototype.constructor.setPrototypeOf) {
	polyfills.push("Object.setPrototypeOf");
	Object.setPrototypeOf = require("./setPrototypeOf").default;
}

// set
declare const Set: {
	prototype: Record<string, any>;
};

// Check if set constructor takes array
if (!window.Set || new window.Set(["hi"]).size === 0) {
	polyfills.push("Set");
	require("core-js/es/set");

	// Some libs expect Set to return this from some methods which core js does not do
	["add", "delete"].forEach((key) => {
		const original = Set.prototype[key];
		Set.prototype[key] = function (...args: any[]) {
			original.apply(this, args);
			return this;
		};
	});
}

// promise

if (!window.Promise) {
	polyfills.push("Promise");
	window.Promise = require("core-js/es/promise");
}

// string

if (!String.prototype.startsWith) {
	polyfills.push("String.startsWith");
	require("core-js/es/string/starts-with");
}

if (!String.prototype.endsWith) {
	polyfills.push("String.endsWith");
	require("core-js/es/string/ends-with");
}

if (!String.prototype.trim) {
	polyfills.push("String.trim");
	require("core-js/es/string/trim");
}

if (!String.prototype.repeat) {
	polyfills.push("String.repeat");
	require("core-js/es/string/repeat");
}

if (!String.prototype.includes) {
	polyfills.push("String.includes");
	require("core-js/es/string/includes");
}

// arrays

if (!Array.prototype.includes) {
	polyfills.push("Array.includes");
	require("core-js/es/array/includes");
}

if (!Array.prototype.fill) {
	polyfills.push("Array.fill");
	require("core-js/es/array/fill");
}

if (!window.Array.from) {
	polyfills.push("Array.from");
	const from = require("core-js/es/array/from");
	window.Array.from = function (arrayLike: ArrayLike<any>) {
		if (arrayLike === undefined || arrayLike === null) return arrayLike;
		return from.call(this, arrayLike);
	};
}

if (!Array.prototype.find) {
	polyfills.push("Array.find");
	require("core-js/es/array/find");
}

if (!Array.prototype.findIndex) {
	polyfills.push("Array.findIndex");
	require("core-js/es/array/find-index");
}

if (!Array.prototype.forEach) {
	polyfills.push("Array.forEach");
	require("core-js/es/array/for-each");
}

declare const NodeList: {
	prototype: {
		forEach?: Function;
	};
};

if (!NodeList.prototype.forEach) {
	polyfills.push("NodeList.forEach");
	NodeList.prototype.forEach = Array.prototype.forEach;
}

// prevent blow up on IE

if (!window.Proxy) {
	polyfills.push("Proxy");
	require("proxy-polyfill");
}

if (!window.EventTarget) {
	polyfills.push("EventTarget");
	window.EventTarget = function () {} as any;
}

if (!window.IntersectionObserver) {
	polyfills.push("IntersectionObserver");
	require("intersection-observer");
}

if (!(window as any).ResizeObserver) {
	polyfills.push("ResizeObserver");
	(window as any).ResizeObserver = require("resize-observer-polyfill").default;
}

if (!Number.isFinite) {
	Number.isFinite = function (number: number) {
		return typeof number === "number" && isFinite(number);
	};
}

if (!Number.isNaN) {
	Number.isNaN = function (input: any) {
		// eslint-disable-next-line no-self-compare
		return typeof input === "number" && input !== input;
	};
}

// Check classlist support
if (
	!("classList" in document.createElement("_")) ||
	// eslint-disable-next-line no-mixed-operators
	(document.createElementNS &&
		!(
			"classList" in document.createElementNS("http://www.w3.org/2000/svg", "g")
		))
) {
	polyfills.push("Element.classList");
	require("classlist-polyfill");
}

if (!window.Symbol) {
	polyfills.push("Symbol");
	window.Symbol = require("core-js/es/symbol");
}

if (!window.btoa) {
	polyfills.push("btoa");
	require("./btoa");
}

if (process.env.NODE_ENV === "development") {
	(window as any).__forceSmoothScrollPolyfill__ = true;
}
smoothscroll.polyfill();

// Element

function sanitizeFunc(func: Function) {
	return function (this: HTMLElement, selector: string) {
		return func.call(this, selector.replace(/--/g, "\\-\\-"));
	};
}

const ElementPrototype: typeof Element.prototype & {
	hasClass?: Function;
	matchesSelector?: typeof Element.prototype.matches;
	mozMatchesSelector?: typeof Element.prototype.matches;
	msMatchesSelector?: typeof Element.prototype.matches;
	oMatchesSelector?: typeof Element.prototype.matches;
} = Element.prototype;

// Fix issue with query selectors in IE 11 downwards
if (isIE) {
	polyfills.push("Element.querySelector");
	polyfills.push("Element.querySelectorAll");
	ElementPrototype.querySelector = sanitizeFunc(ElementPrototype.querySelector);
	ElementPrototype.querySelectorAll = sanitizeFunc(
		ElementPrototype.querySelectorAll,
	);
	if (ElementPrototype.hasClass) {
		ElementPrototype.hasClass = sanitizeFunc(ElementPrototype.hasClass);
	}
}

if (!ElementPrototype.remove) {
	polyfills.push("Element.remove");
	(function (arr) {
		arr.forEach((item) => {
			// eslint-disable-next-line no-prototype-builtins
			if (item.hasOwnProperty("remove")) {
				return;
			}
			Object.defineProperty(item, "remove", {
				configurable: true,
				enumerable: true,
				writable: true,
				value: function remove() {
					if (this.parentNode !== null) this.parentNode.removeChild(this);
				},
			});
		});
	})([ElementPrototype, CharacterData.prototype, DocumentType.prototype]);
}

if (!ElementPrototype.matches) {
	polyfills.push("Element.matches");

	ElementPrototype.matches =
		ElementPrototype.matchesSelector ||
		ElementPrototype.mozMatchesSelector ||
		ElementPrototype.msMatchesSelector ||
		ElementPrototype.oMatchesSelector ||
		ElementPrototype.webkitMatchesSelector ||
		function (this: Element, s: string) {
			const matches = (
				(this as any).document || this.ownerDocument
			).querySelectorAll(s);
			let i = matches.length;
			// eslint-disable-next-line no-empty
			while (--i >= 0 && matches.item(i) !== this) {}
			return i > -1;
		};
}

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === "test" || !window.requestAnimationFrame) {
	polyfills.push("window.requestAnimationFrame");
	require("raf").polyfill(window);
}

window.__polyfills = polyfills.sort();
